import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-network-roce",
  "use": "app-icon-network-roce-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-network-roce\"><path d=\"M17.143 5.143H24V24H0V5.143h6.858V0h10.285v5.143zM17 18h4v-6h-4v6zm-7 0h4v-6h-4v6zm-7 0h4v-6H3v6z\" fill=\"#6C92FA\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol